//* 지갑 API
// 2025.01.28
// 희문

import * as BaseApi from "api/Base.api";

//* 지갑 잔액 조회
export const getBalance = async () => {
    const url = `/student/v2/wallet/balance`;
    return await BaseApi.get(url);
};

export interface IWalletHistoryItem {
    id: string;
    type: "credit" | "debit";
    amount: number;
    date: string;
    orderTitle?: string | null;
    coinOrderStatusCode?: string;
}

export interface IWalletHistoryResponse {
    list: IWalletHistoryItem[];
    pagination: { page: number; limit: number; totalCount: number };
}

//* 지갑 사용 내역 조회
export const getHistory = async (params?: { page?: number; limit?: number }) => {
    const url = `/student/v2/wallet/history`;
    return await BaseApi.get(url, params ?? {}) as IWalletHistoryResponse;
};

export interface ICoinProductItem {
    id: number;
    coinProductCode: string;
    displayName: string;
    grantCoinAmount: number;
    bonusCoinAmount: number;
    priceAmount: number | null;
    priceCurrencyCode: string | null;
    isHit: number;
    isRecommended: number;
    skuId: number | null;
    storeSkuId: string | null;
}

export interface ICoinProductsResponse {
    list: ICoinProductItem[];
}

//* 코인 상품 목록 조회 (코인스토어 팝업용). salesChannelCode 에 따라 해당 채널/스토어 가격 반환.
//  salesChannel:web → storeProvider:paddle, salesChannel:ios → appstore, salesChannel:android → googlePlay
export const getCoinProducts = async (params?: { salesChannelCode?: string }) => {
    const url = `/student/v2/wallet/coin-products`;
    return await BaseApi.get(url, params ?? {}) as ICoinProductsResponse;
};

export interface ICheckoutUrlResponse {
    checkoutUrl: string;
}

//* 웹 결제용 체크아웃 URL 조회 (같은 탭 이동 또는 Paddle 등 연동 URL)
export const getCheckoutUrl = async (params: { coinProductId: number; storeSkuId: string | null }) => {
    const url = `/student/v2/wallet/checkout-url`;
    return await BaseApi.get(url, params) as ICheckoutUrlResponse;
};

export interface ICompletePurchaseResponse {
    balance: number;
    totalCoinAmount: number;
    orderTitle: string;
}

//* 상품 클릭 시 바로 결제 완료. IAP 시 storeTransactionId/platform 전달 시 웹훅 환불 매칭됨
export const completePurchase = async (params: {
    coinProductId: number;
    storeSkuId?: string | null;
    storeTransactionId?: string | null;
    platform?: "ios" | "android";
}) => {
    const url = `/student/v2/wallet/complete-purchase`;
    const response = await BaseApi.post(url, params) as { status: number; data: ICompletePurchaseResponse };
    return response.data;
};

export interface IVerifyIapPurchaseRequest {
    purchase: unknown;
    verifyKey: string;
    requireSigned: boolean;
    /** "ios" | "android" — 미전달 시 purchase 형태로 추론 */
    platform?: "ios" | "android";
    productId?: string;
    requestId?: string;
    /** 전달 시 검증 성공 시 서버에서 바로 잔액 적립 후 balance/totalCoinAmount/orderTitle 반환 */
    coinProductId?: number;
    storeSkuId?: string | null;
}

export interface IVerifyIapPurchaseResponse {
    verified: boolean;
    token?: string;
    storeTransactionId?: string;
    platform?: "ios" | "android";
    /** coinProductId로 호출 시 검증 성공 후 서버에서 적립한 결과 */
    balance?: number;
    totalCoinAmount?: number;
    orderTitle?: string;
}

//* IAP 결제 검증: thpe-api-payment 직접 호출 (앱 verify_required 시 extra.purchase 전달)
export const verifyIapPurchase = async (params: IVerifyIapPurchaseRequest) => {
    const base = process.env.REACT_APP_API_PAYMENT_URL || process.env.REACT_APP_API_URL;
    const path = "/student/v2/wallet/verify-iap-purchase";
    const url = base ? `${String(base).replace(/\/$/, "")}${path}` : path;
    const response = await BaseApi.post(url, params) as { status: number; data: IVerifyIapPurchaseResponse };
    return response.data;
};
